<phx-select
    #selectComponent
    [items]="selectOptions()"
    [(value)]="value"
    [placeholder]="placeholder()"
    optionLabel="label"
    optionValue="value"
    (valueChange)="this.formControl.setValue($event)"
    (onFilter)="this.refresh()"
/>
